export default __webpack_public_path__ + "static/processexplanation-miracl-desktop-6b263d700dd67d27777b6ba83a0a06f8.svg";